import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toCApi } from "../../../utils";
import CurriculumDesc from "./CurriculumDesc";
import classes from "./Curriculum.module.css"
import { throwApiError } from "../../lms-shared/store/error-handling-actions";

const Curriculum = ({ data }) => {
    const direction = useSelector(state => state.translate.direction);
    const [topicsData, setTopicsData] = useState();
    const dispatch = useDispatch()


    useEffect(() => {
        if (data && data.id) {
            toCApi.toCFilterRangePost({ toCRangeFilter: { courseId: data.id } }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "toCFilterRangePost " + error.message, level: 1, component: "Curriculum", line: 18 }))
                }
                else {
                    setTopicsData(response.body)
                }
            })
        }
    }, [data])

    return <div className={`${classes[direction]} `}>
        {data && <div className={classes.Wrap}>
            <div className={classes.TitleImg} style={{ backgroundImage: `url(${data.pageBackgroundImage})` }}></div>
            <CurriculumDesc data={data} topicsData={topicsData}></CurriculumDesc>
        </div>
        }
    </div>
}

export default Curriculum;